var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPillar2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.9,
    height: 66,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#fff}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_",
    transform: "translate(0 -1020.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st0",
    d: "M27.3 1020.4c-1 0-1.8.8-1.8 1.8v6.1h28.3v-6.1c0-1-.8-1.8-1.8-1.8h-2.8v3.1c0 .7-.5 1.2-1.2 1.2s-1.2-.5-1.2-1.2v-3.1h-3.1v3.1c0 .7-.5 1.2-1.2 1.2s-1.2-.5-1.2-1.2v-3.1h-3.1v3.1c0 .7-.5 1.2-1.2 1.2s-1.2-.5-1.2-1.2v-3.1h-3.1v3.1c0 .7-.5 1.2-1.2 1.2s-1.2-.5-1.2-1.2v-3.1h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "st0",
    d: "M26.4 1030.8l5.1 8h27.7l-4.9-8H26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st0",
    d: "M23.7 1030.8l-4.9 8h9.9l-5-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st0",
    d: "M18.1 1041.3v12.1c.7-.2 1.4-.3 2.1-.4 1.4-.2 2.5-.2 2.5-.2h2.7l-.6 2.6s-.2.9-.6 2c-.4 1.1-.7 2.3-1.9 3.4-1.4 1.2-2.9 1.6-4.2 1.9 2.3.3 4.6 1.2 6.2 3.1 2.1 2.5 2.3 5.6 2.4 8.1 0 2.8-.5 5.9-2.2 8.6-.8 1.3-1.9 2.5-3.1 3.6h7.8v-44.9l-11.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st0",
    d: "M31.7 1041.3v44.9H60v-44.9H31.7zm14.1 17.5s3.4 5.5 3.4 7c0 1.6-1.5 2.8-3.4 2.8s-3.4-1.3-3.4-2.8c0-1.6 3.4-7 3.4-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st0",
    d: "M12.3 1085.7s2.9 1 4.3.6c2.5-.7 4.7-2.7 6.1-4.9 1.4-2.1 1.9-4.8 1.8-7.4 0-2.3-.3-5-1.8-6.8-1.3-1.5-3.5-2.4-5.5-2.5-1.7-.1-4.9 1.8-4.9 1.8s-3.2-1.9-4.9-1.8c-2 .1-4.2.9-5.5 2.5-1.5 1.8-1.8 4.4-1.8 6.8 0 2.5.5 5.2 1.8 7.4 1.4 2.2 3.6 4.2 6.1 4.9 1.4.4 4.3-.6 4.3-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st0",
    d: "M15.4 1061.1s.5-3.8 1.8-4.9c1.4-1.2 5.5-1.2 5.5-1.2s-.7 3.2-1.8 4.3c-1.4 1.3-5.5 1.8-5.5 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st0",
    d: "M8.5 1058.1c-.7 0-1.2.6-1.1 1.3 0 .4.3.8.6 1l.6.3c1.9 1.1 3.1 3.1 3.1 5.3v1.2c0 .7.5 1.2 1.2 1.2s1.2-.5 1.2-1.2v-1.2c0-3.1-1.7-5.9-4.3-7.5l-.6-.3c-.2 0-.5-.1-.7-.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillar2);
export default __webpack_public_path__ + "static/media/pillar2.4aa85ce959a6e74d02a58a3e08da5bcd.svg";
export { ForwardRef as ReactComponent };